import {
  ChangeDetectionStrategy,
  Component,
  OnInit
} from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { HrefDirective } from '../../../directives/href/href.directive';
import { IconComponent } from '../../../components/icon/icon.component';
import { SecurityService } from '../../../services/security.service';
/**
 * Search Navigation Component
 *
 * This is the search navigation for Menu Component, it holds the search
 */
@Component({
  selector: 'td-wb-menu-search-navigation',
  templateUrl: 'search-navigation.component.html',
  styleUrls: ['search-navigation.component.scss'],
  imports: [
    TranslateDirective,
    HrefDirective,
    IconComponent,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuSearchNavigationComponent implements OnInit {
  searchPermission: boolean;

  constructor(private securityService: SecurityService) {
  }

  ngOnInit(): void {
    this.searchPermission = this.securityService.hasPermission('SEARCH');
  }
}
